var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 25C6.37258 25 1 19.6274 1 13C1 6.37258 6.37258 1 13 1C19.6274 1 25 6.37258 25 13C25 19.6274 19.6274 25 13 25Z",
    stroke: "url(#paint0_linear_173_14832)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 16C18.4 16 16.6 18.4 13 18.4C9.39998 18.4 7.59998 16 7.59998 16",
    stroke: "url(#paint1_linear_173_14832)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 9.4C16.8687 9.4 16.6 9.13137 16.6 8.8C16.6 8.46863 16.8687 8.2 17.2 8.2C17.5313 8.2 17.8 8.46863 17.8 8.8C17.8 9.13137 17.5313 9.4 17.2 9.4Z",
    stroke: "url(#paint2_linear_173_14832)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79995 9.4C8.46858 9.4 8.19995 9.13137 8.19995 8.8C8.19995 8.46863 8.46858 8.2 8.79995 8.2C9.13132 8.2 9.39995 8.46863 9.39995 8.8C9.39995 9.13137 9.13132 9.4 8.79995 9.4Z",
    stroke: "url(#paint3_linear_173_14832)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_14832",
    x1: 1.58279,
    y1: 2.01361,
    x2: 1.58279,
    y2: 20.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_173_14832",
    x1: 6.76226,
    y1: 13.9241,
    x2: 6.76226,
    y2: 15.8076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_173_14832",
    x1: 14.0291,
    y1: 7.39139,
    x2: 14.0291,
    y2: 8.33311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_173_14832",
    x1: 7.02914,
    y1: 7.39139,
    x2: 7.02914,
    y2: 8.33311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiIconActive);
export default __webpack_public_path__ + "static/media/emoji_icon_active.f120ae0baf64ae12fcd1d89ea8d4888a.svg";
export { ForwardRef as ReactComponent };